export const carrierTypeConfig = {
  0: { label: '手機條碼載具', value: '0' },
  1: { label: '自然人憑證', value: '1' },
}

export const carrierTypeOptions = Object.values(carrierTypeConfig)

export const invoiceTypeDisplayConfig = {
  C: { label: '二聯式發票', shortLabel: '二聯' },
  B: { label: '三聯式發票', shortLabel: '三聯' },
  carrier: { label: '手機載具', shortLabel: '手機' },
}

const hasCarrier = (carrierType) => {
  return carrierType !== undefined && carrierType !== null && carrierType !== ''
}

export const getCarrierTypeLabel = (carrierType) => {
  return carrierTypeConfig[carrierType]?.label || '-'
}

export const getInvoiceDisplayTypeKey = ({ buyerType, carrierType } = {}) => {
  if (buyerType === 'carrier' || hasCarrier(carrierType)) return 'carrier'
  if (buyerType === 'B') return 'B'
  if (buyerType === 'C') return 'C'
  return null
}

export const getInvoiceTypeLabel = (payload) => {
  const typeKey = getInvoiceDisplayTypeKey(payload)
  return typeKey ? invoiceTypeDisplayConfig[typeKey].label : '-'
}

export const getInvoiceTypeShortLabel = (payload) => {
  const typeKey = getInvoiceDisplayTypeKey(payload)
  return typeKey ? invoiceTypeDisplayConfig[typeKey].shortLabel : '-'
}

export const normalizeInvoiceFormType = ({ buyerType, carrierType } = {}) => {
  return getInvoiceDisplayTypeKey({ buyerType, carrierType }) || buyerType || null
}

export const serializeInvoiceBuyerType = (buyerType) => {
  if (!buyerType) return buyerType
  return buyerType === 'carrier' ? 'C' : buyerType
}

export const invoiceTypeWithCarrierList = [
  { value: 'C', label: '二聯式發票' },
  { value: 'B', label: '三聯式發票（公司戶）' },
  { value: 'carrier', label: '手機載具' },
]

export const invoiceModeConfig = {
  dev: { label: '測試環境', value: 'dev' },
  prod: { label: '正式環境', value: 'prod' },
}

export const invoicePrinterModelConfig = {
  epsonTmM30iii: { label: 'Epson TM-m30III', value: 'epson_tm_m30iii' },
}

export const salesDefaultInvoiceOptionsConfig = {
  none: { value: 'none', label: '不開立' },
  issue: { value: 'issue', label: '開立發票' },
}

export const invoiceAmountTaxTypeConfig = {
  taxable: { label: '應稅', value: 'taxable' },
}
